import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./module/user/pages/Home.jsx";

import Navbar from "./layouts/Navbar";
import Usernavbar from './layouts/Usernavbar';
import Managernavbar from './layouts/Managernavbar';
import Adminnavbar from './layouts/Adminnavbar';
import Fmnavbar from './layouts/Fmnavbar';
import Userhome from './module/user/pages/Userhome.jsx'
import Userdashbord from './module/user/pages/Userdashbord.jsx'
import Usercompany from './module/user/pages/Usercompany.jsx'
import './App.css';
import Usersidebar from "./layouts/Usersidebar.jsx";
import Managersidebar from './layouts/Managersidebar';
import Adminsidebar from './layouts/Adminsidebar.jsx';
import Fmsidebar from './layouts/Fmsidebar.jsx';
import Directeory from './module/user/pages/Directeory.jsx';
import Profesanal from './module/user/pages/Profesanal.jsx'
import Attendancnewpage from './module/user/pages/Attendancnewpage';
import Payroll from './module/user/pages/Payroll.jsx';
import Tickting from './module/user/pages/Tickting.jsx';

// >>>>>>>>>>&&&&&&&&&> Manager import all file>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
import Managerdashbord from './module/manager/pages/Managerdashbord.jsx';
import Managercompany from './module/manager/pages/Managercompany';
import Mangerdirecteory from './module/manager/pages/Mangerdirecteory';
import Managerprofile from './module/manager/pages/Managerprofile';
import Managerprofesanl from './module/manager/pages/Managerprofesanl';
import Managerattendance from './module/manager/pages/Managerattendance';
import Managerpayroll from './module/manager/pages/Managerpayroll';
import Managertickting from './module/manager/pages/Managertickting';
import Asets from './module/manager/pages/Asets';



//>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Admin-all>>>>>>>>>>>>>>>>>>>>>>>>>>
import Adminhome from './module/admin/pages/Adminhome.jsx'
import Adminsubscription from './module/admin/pages/Adminsubscription'
import Adminhrm from './module/admin/pages/Adminhrm'
import Adminticket from './module/admin/pages/Adminticket.jsx'
// >>>>>>>>>>>>>>>>>>>>>FM all import >>>>>>>>>>>>>>>>

 
import Fmdashbord from './module/fm/pages/Fmdashbord.jsx'
import FmAttendanceTable from "./module/fm/pages/FmAttendanceTable.jsx";
import Fmpage from "./module/fm/pages/Fmpage.jsx";


function Layout() {

  const location = useLocation();
  const showLayout =
    location.pathname === "/";


    const showLayout1 =
    location.pathname === "/userhome"||
    location.pathname === "/Userdashbord"||
    location. pathname=== "/Usercompany"||
    location.pathname=== "/Directeory"||
    location.pathname==="/professional"||

    location .pathname==="/attendance"||
    location.pathname==="/Payroll"||
    location .pathname === "/Tickting";

    const showLayout2 =
    location.pathname === "/Managerdashbord"||
    location.pathname=== "/Managercompany"||
    location.pathname=== "/Mangerdirecteory"||
    location.pathname=== "/Managerprofile"||
     location.pathname=== "/Managerprofesanl"||
      location.pathname=== "/Managerattendance"||
        location.pathname=== "/Managerpayroll"||
         location.pathname=== "/Managertickting"||
          location.pathname=== "/Asets";


          const showLayout3 =
    location.pathname === "/Adminhome"||
    location.pathname === "/Adminsubscription"||
    location.pathname === "/Adminhrm"||
    location.pathname === "/Fmpage"||
    location.pathname === "/Adminticket";

    const showLayout4 =
    location.pathname === "/Fmdashbord"||
    location.pathname === "/FmAttendanceTable";
   
   
   




  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column",overflow:"auto",scrollbarWidth:"none" }}>
      {showLayout && <Navbar />}
      {showLayout1 && <Usernavbar />}
       {showLayout2 && <Managernavbar />}

       {showLayout3 && <Adminnavbar />}
       {showLayout4 && <Fmnavbar />}
       
      <div style={{ display: "flex", flexGrow: 1 }}>
        {showLayout1 && <Usersidebar />}
        {showLayout2 && <Managersidebar />}
        {showLayout3 && <Adminsidebar />}
        {showLayout4 && <Fmsidebar />}
         
        
        <div style={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path ="/userhome"element= {<Userhome/>}/>
            <Route path="/Userdashbord"element= {<Userdashbord/>}/>
            <Route path="/Usercompany" element= {<Usercompany/>}/>
            <Route path="/Directeory"element= {<Directeory/>}/>
            <Route path ="/professional"element={<Profesanal/>}/>
            <Route path = "/attendance" element= {<Attendancnewpage/>}/>
            <Route path="/Payroll" element={<Payroll/>}/>
            <Route path="/Tickting"element={<Tickting/>}/>
          {/* <<<<<<<<<<<manager all data <<<<<<<<<<<<<<<<<<<<< */}

          <Route path="/Managerdashbord"element={<Managerdashbord/>}/>
          <Route path="/Managercompany"element={<Managercompany/>}/>
          <Route path="/Mangerdirecteory"element={<Mangerdirecteory/>}/>
          <Route path="/Managerprofile"element={<Managerprofile/>}/>
           <Route path="/Managerprofesanl"element={<Managerprofesanl/>}/>
            <Route path="/Managerattendance"element={<Managerattendance/>}/>
             <Route path="/Managerpayroll"element={< Managerpayroll/>}/>
              <Route path="/Managertickting"element={< Managertickting/>}/>
               <Route path="/Asets"element={< Asets/>}/>


{/* <<<<<<<<<<<<<<<<<<<<<<<<<<<<> Admin all import>>>>>>>>>>>>>>>>></> */}
   <Route path="/Adminhome"element={< Adminhome/>}/>
   <Route path="/Adminsubscription"element={< Adminsubscription/>}/>
    <Route path="/Adminhrm"element={<Adminhrm/>}/>
    <Route path="/Adminticket"element={< Adminticket/>}/>

    
    
    <Route path="/Fmdashbord"element={< Fmdashbord/>}/>   
    <Route path="/FmAttendanceTable"element={< FmAttendanceTable/>}/> 
    <Route path="/Fmpage"element={< Fmpage/>}/>
          
          </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;

